module.exports = __webpack_public_path__ + "lp/img/translate_icn.decc6c6f.svg";